import React, { useContext } from 'react';
import { getSharedPremiumResource, PremiumSharedResource } from '../../premium-api';
import { mergeQueryOptions } from '../Utils/internal';
const QueryOptionsContext = getSharedPremiumResource(PremiumSharedResource.QueryOptionsContext, () => /*#__PURE__*/React.createContext({}));
export const QueryOptionsProvider = _ref => {
  let {
    children,
    tags,
    groupId,
    hooksOnly,
    ...options
  } = _ref;
  const existingValues = React.useContext(QueryOptionsContext);
  return /*#__PURE__*/React.createElement(QueryOptionsContext.Provider, {
    value: {
      hooksOnly: hooksOnly != null ? hooksOnly : existingValues.hooksOnly,
      queryOptions: mergeQueryOptions(existingValues.queryOptions, options, {
        meta: {
          tags,
          groupId
        }
      })
    }
  }, children);
};
export const useQueryOptionsContext = () => {
  var _useContext;
  const {
    queryOptions,
    hooksOnly
  } = (_useContext = useContext(QueryOptionsContext)) != null ? _useContext : {};
  return {
    queryOptions,
    hooksOnly
  };
};
//# sourceMappingURL=QueryOptionsProvider.js.map